class ChatWidget {
  constructor({ iframeUrl, header, colors }) {
    this.iframeUrl = iframeUrl
    this.header = header
    this.colors = colors
    this.init()
  }

  init() {
    this.importCss()
    this.createHtml()
    this.addEventListeners()
    this.listenIframeMessage()
  }
  getHeader() {
    return `${this.header}`
  }
  addEventListeners() {
    const chatWidget = document.getElementById('s-chat-widget')
    chatWidget.addEventListener('click', () => {
      chatWidget.classList.toggle('opened')
    })
  }
  listenIframeMessage() {
    window.addEventListener('message', (event) => {
      try {
        const data = JSON.parse(event.data)
        if (data.type === 'healthCheck') {
          if (data.data.isConnected) {
            const chatWidget = document.getElementById('s-chat-widget')
            chatWidget.style.display = 'block'
          }
        }
      } catch {}
    })
  }
  createHtml() {
    const html = `
              <div id="s-chat-widget" class="s-chat-widget">
                  <div class="s-chat-widget-header" style="background-color: ${
                    this.colors.header
                  }; color: ${this.colors.headerText};">
                       ${this.getHeader()}
                  </div>
                  <div class="s-chat-widget-body" style="background-color: ${
                    this.colors.body
                  }; color: ${this.colors.bodyText};">
                      <iframe src="${this.iframeUrl}" frameborder="0"></iframe>
                  </div>
              </div>
          `
    document.body.insertAdjacentHTML('beforeend', html)
  }
  importCss() {
    const css = `
          <link rel="stylesheet" href="https://chatbot.softwaremaklerpro.de/chat-widget.css">
      `
    document.head.insertAdjacentHTML('beforeend', css)
  }
}

module.exports.startChatWidget = (lang) => {
  const language = lang || 'tr'
  const header =
    language === 'tr'
      ? 'Heo<span>AI</span> ile görüş'
      : 'Talk to Heo<span>AI</span>'
  new ChatWidget({
    iframeUrl: `https://chatbot.softwaremaklerpro.de?isStudent=true&lang=${language}`,
    header: `<section id="s-chat-widget-section">
    <div class='s-chat-widget-header-logo'><img src='/panel/images/ai2.svg' alt='HeoAI' /> ${header}</div>
    <div class='s-chat-widget-header-text'><img src='/panel/images/ai2.svg' alt='HeoAI' /></div>
    </section>`,
    colors: {
      header: 'var(--primary-color)',
      headerText: 'var(--banner-text-color)',
      body: 'var(--primary-color)',
      bodyText: 'var(--banner-text-color)',
    },
  })
}
